module.exports = __webpack_public_path__ + "img/sidebar-curve-small.03fa448a.svg";